import type { FunctionComponent } from "react";

export const NotFound: FunctionComponent = () => {
	return <p className="font-bold text-white">404 Not Found</p>;
};
